import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_261: DocMigration = {
  maxSchemaVersion: "0.0.261",
  description: "Migrate Foundation Datums to Datum Catalog Settings",
  apply(json: any) {
    if (json.settings) {
      const datums = {};

      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type !== "FOUNDATION_CATALOG_SETTINGS") {
          continue;
        }

        if (!setting.foundationDatums) {
          continue;
        }

        for (const datumId in setting.foundationDatums) {
          const datum = setting.foundationDatums[datumId];
          datums[datumId] = datum;
        }
      }

      if (Object.keys(datums).length) {
        if (!json.settingsSets) {
          json.settingsSets = {};
        }

        const settingsSetId = uid();
        const settingsSet = {
          entityType: "SETTINGS_SET",
          name: "Datums Setting Set",
          id: settingsSetId,
          sortIndex: 0,
        };

        const datumSettingId = uid();
        const datumSettings = {
          id: datumSettingId,
          type: "DATUM_CATALOG_SETTINGS",
          entityType: "SETTINGS",
          name: "Datum Catalog Settings",
          sortIndex: 0,
          parentId: settingsSetId,
          datums,
        };

        json.settings[datumSettingId] = datumSettings;
        json.settingsSets[settingsSetId] = settingsSet;
      }
    }

    return json;
  },
};

export default migration_0_0_261;
